// extracted by mini-css-extract-plugin
export default {"TabListClass":"summary_TabListClass__hVx5I"};